import React from "react";

const Carat = ({collapse, setCollapse}) => {

  let caretDirection = collapse ? "down" : "up"
  return <i className={`fa fa-angle-${caretDirection} carat`} onClick={() => {setCollapse(!collapse)}}/>
}

export default Carat